"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationUpdateDto = instanceOfOrientationUpdateDto;
exports.OrientationUpdateDtoFromJSON = OrientationUpdateDtoFromJSON;
exports.OrientationUpdateDtoFromJSONTyped = OrientationUpdateDtoFromJSONTyped;
exports.OrientationUpdateDtoToJSON = OrientationUpdateDtoToJSON;
exports.OrientationUpdateDtoToJSONTyped = OrientationUpdateDtoToJSONTyped;
const StipendCreateDto_1 = require("./StipendCreateDto");
const OrientationSessionUpdateDto_1 = require("./OrientationSessionUpdateDto");
const LicenseType_1 = require("./LicenseType");
/**
 * Check if a given object implements the OrientationUpdateDto interface.
 */
function instanceOfOrientationUpdateDto(value) {
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    if (!('totalRate' in value) || value['totalRate'] === undefined)
        return false;
    if (!('totalSeats' in value) || value['totalSeats'] === undefined)
        return false;
    if (!('specialtyCode' in value) || value['specialtyCode'] === undefined)
        return false;
    if (!('orientationSessions' in value) || value['orientationSessions'] === undefined)
        return false;
    return true;
}
function OrientationUpdateDtoFromJSON(json) {
    return OrientationUpdateDtoFromJSONTyped(json, false);
}
function OrientationUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'licenseType': (0, LicenseType_1.LicenseTypeFromJSON)(json['licenseType']),
        'description': json['description'] == null ? undefined : json['description'],
        'totalRate': json['totalRate'],
        'totalSeats': json['totalSeats'],
        'specialtyCode': json['specialtyCode'],
        'stipendMinimumDistance': json['stipendMinimumDistance'] == null ? undefined : json['stipendMinimumDistance'],
        'isSearchable': json['isSearchable'] == null ? undefined : json['isSearchable'],
        'orientationSessions': (json['orientationSessions'].map(OrientationSessionUpdateDto_1.OrientationSessionUpdateDtoFromJSON)),
        'stipends': json['stipends'] == null ? undefined : (json['stipends'].map(StipendCreateDto_1.StipendCreateDtoFromJSON)),
    };
}
function OrientationUpdateDtoToJSON(json) {
    return OrientationUpdateDtoToJSONTyped(json, false);
}
function OrientationUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'licenseType': (0, LicenseType_1.LicenseTypeToJSON)(value['licenseType']),
        'description': value['description'],
        'totalRate': value['totalRate'],
        'totalSeats': value['totalSeats'],
        'specialtyCode': value['specialtyCode'],
        'stipendMinimumDistance': value['stipendMinimumDistance'],
        'isSearchable': value['isSearchable'],
        'orientationSessions': (value['orientationSessions'].map(OrientationSessionUpdateDto_1.OrientationSessionUpdateDtoToJSON)),
        'stipends': value['stipends'] == null ? undefined : (value['stipends'].map(StipendCreateDto_1.StipendCreateDtoToJSON)),
    };
}
//# sourceMappingURL=OrientationUpdateDto.js.map